/**
 * Russian pluralization rule for vue-i18n 8.x.
 *
 * vue-i18n 8 ships only the English (singular | plural) rule out of the box.
 * For the consent dialog we need 4-form Russian plurals
 * ("1 час | 1 час | 2 часа | 5 часов") so callers can register this rule
 * under the "ru" locale via:
 *
 *   const i18n = new VueI18n({
 *     ...,
 *     pluralizationRules: { ru: ruPluralizationRule }
 *   });
 *
 * For projects whose i18n instance is already constructed elsewhere this
 * module also provides `installRuPluralization(i18n)` which patches an
 * existing instance non-destructively (it merges, never replaces other
 * locales' rules).
 *
 * Returned index matches vue-i18n's `choice` semantics:
 *   0 - special "no items" form (we reuse the singular form here)
 *   1 - singular form  (1, 21, 31...)
 *   2 - few            (2-4, 22-24...)
 *   3 - many           (0, 5-20, 25-30...)
 */
export function ruPluralizationRule(choice, choicesLength) {
  if (choice === 0) {
    return 0;
  }
  const teen = choice > 10 && choice < 20;
  const endsWithOne = choice % 10 === 1;
  if (!teen && endsWithOne) {
    return choicesLength < 4 ? 0 : 1;
  }
  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
    return choicesLength < 4 ? 1 : 2;
  }
  return choicesLength < 4 ? 2 : 3;
}

export function installRuPluralization(i18n) {
  if (!i18n) return;
  // vue-i18n 8 stores rules on the underlying _vm; safe public API is the
  // `pluralizationRules` option, but it can be mutated after construction:
  const existing = i18n.pluralizationRules || {};
  if (existing.ru === ruPluralizationRule) return;
  i18n.pluralizationRules = Object.assign({}, existing, {ru: ruPluralizationRule});
}
